module.exports = __webpack_public_path__ + "img/symbol_8.7f198316.png";